import { createVNode as _createVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-8ebf2ace")

_pushScopeId("data-v-8ebf2ace")
const _hoisted_1 = { class: "main__section" }
const _hoisted_2 = /*#__PURE__*/_createVNode("h2", { class: "-bold" }, "신청 상세정보", -1)
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_RequestView = _resolveComponent("RequestView")
  const _component_CancelConfirm = _resolveComponent("CancelConfirm")

  return (_openBlock(), _createBlock("main", null, [
    _createVNode("section", _hoisted_1, [
      _createVNode(_component_RequestView, {
        onCancelRequest: [
          _ctx.CancelRequest,
          _cache[1] || (_cache[1] = (id)=>{_ctx.CancelRequest(id)})
        ],
        id: _ctx.state.id
      }, {
        title: _withId(() => [
          _hoisted_2
        ]),
        _: 1
      }, 8, ["onCancelRequest", "id"]),
      _createVNode(_component_CancelConfirm, {
        ref: "cancel$",
        accept: _ctx.CancelAccept
      }, null, 8, ["accept"])
    ])
  ]))
})